'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _loader = require('../loader');

var _loader2 = _interopRequireDefault(_loader);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var cx = _bind2.default.bind(_style2.default);

var Pill = function Pill(_ref) {
  var children = _ref.children,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === undefined ? 'active' : _ref$appearance,
      _ref$focused = _ref.focused,
      focused = _ref$focused === undefined ? false : _ref$focused,
      _ref$fetching = _ref.fetching,
      fetching = _ref$fetching === undefined ? false : _ref$fetching,
      _ref$clickable = _ref.clickable,
      clickable = _ref$clickable === undefined ? false : _ref$clickable,
      _ref$separated = _ref.separated,
      separated = _ref$separated === undefined ? false : _ref$separated,
      onClick = _ref.onClick;
  return _react2.default.createElement('div', {
    className: cx('xsui-pill', 'xsui-pill--appearance-' + appearance, focused && 'xsui-pill--focused', (clickable || onClick) && 'xsui-pill--clickable'),
    onClick: fetching ? function () {
      return void 0;
    } : onClick
  }, _react2.default.createElement('div', {
    className: cx('xsui-pill__wrapper')
  }, fetching && _react2.default.createElement('div', {
    className: cx('xsui-pill__wrapper--fetching')
  }, _react2.default.createElement(_loader2.default, {
    size: 'xs',
    color: 'inherit',
    fullscreen: true
  })), _react2.default.createElement('div', {
    className: cx('xsui-pill_entry', fetching && 'xsui-pill_entry--fetching')
  }, children)), onClick && _react2.default.createElement('div', {
    className: cx('xsui-pill_trigger', separated && 'xsui-pill_trigger--separated')
  }, _react2.default.createElement(_icon2.default, {
    name: 'expand'
  })));
};

Pill.propTypes = {
  children: function children() {
    return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
  },
  appearance: _propTypes2.default.oneOf(['active', 'branding', 'warning', 'error', 'info', 'cancelled']),
  focused: _propTypes2.default.bool,
  fetching: _propTypes2.default.bool,
  clickable: _propTypes2.default.bool,
  separated: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};
exports.default = Pill;